/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sbp from '@sbp/sbp'
import { mapGetters, mapState } from 'vuex'
import Avatar from '../../../../frontend/views/components/Avatar.vue'
import Badge from '../../../../frontend/views/components/Badge.vue'
import Tooltip from '../../../../frontend/views/components/Tooltip.vue'
import { OPEN_MODAL } from '../../../../frontend/utils/events.js'
import { fetchNews } from '../../../../frontend/views/utils/misc.js'

const __vue_script__ = ({
  name: 'GroupsList',
  components: {
    Avatar,
    Badge,
    Tooltip
  },
  data () {
    return {
      ephemeral: {
        latestNewsDate: null
      }
    }
  },
  created () {
    this.checkForNewNews()
  },
  computed: {
    ...mapState([
      'currentGroupId'
    ]),
    ...mapGetters([
      'groupsByName',
      'groupUnreadMessages',
      'unreadGroupNotificationCountFor',
      'ourPreferences'
    ]),
    badgeVisiblePerGroup () {
      return Object.fromEntries(
        this.groupsByName.map(group => ([
          group.contractID,
          this.groupUnreadMessages(group.contractID) + this.unreadGroupNotificationCountFor(group.contractID) > 0
        ]))
      )
    },
    isInGlobalDashboard () {
      return this.$route.path.startsWith('/global-dashboard')
    },
    hasNewNews () {
      // Don't show badge if we're currently on the news page
      if (this.$route.path === '/global-dashboard/news-and-updates' ||
        !this.ourPreferences?.lastSeenNewsDate ||
        !this.ephemeral.latestNewsDate
      ) {
        return false
      }

      return new Date(this.ephemeral.latestNewsDate) > new Date(this.ourPreferences.lastSeenNewsDate)
    }
  },
  methods: {
    openModal (mode) {
      sbp('okTurtles.events/emit', OPEN_MODAL, mode)
    },
    handleMenuSelect (id) {
      id && this.changeGroup(id)

      if (this.isInGlobalDashboard) {
        this.$router.push('/dashboard')
      }
    },
    onGlobalDashboardClick () {
      this.$router.push(({ path: '/global-dashboard' }))
    },
    changeGroup (hash) {
      const path = this.$route.path
      const emptyGroupPicture = this.groupPictureForContract(hash) === ''
      if (hash !== this.currentGroupId) {
        sbp('gi.app/group/switch', hash)
      }
      if (emptyGroupPicture && path !== '/pending-approval') {
        this.$router.push(({ path: '/pending-approval' }))
      } else if (!emptyGroupPicture && path === '/pending-approval') {
        this.$router.push(({ path: '/dashboard' }))
      }
    },
    groupPictureForContract (contractID) {
      return this.$store.state[contractID]?.settings?.groupPicture || ''
    },
    async checkForNewNews () {
      try {
        const data = await fetchNews()
        if (data.length > 0) {
          this.ephemeral.latestNewsDate = data[0].createdAt
        }
      } catch (error) {
        console.error('Failed to check for new news:', error)
      }
    }
  }
}        )

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.groupsByName.length
    ? _c(
        "ul",
        { staticClass: "c-group-list", attrs: { "data-test": "groupsList" } },
        [
          _c(
            "li",
            {
              staticClass: "c-group-list-item group-badge",
              class: { "is-active": _vm.isInGlobalDashboard },
            },
            [
              _c(
                "tooltip",
                {
                  attrs: {
                    direction: "right",
                    text: _vm.L("Global dashboard"),
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "c-group-picture is-unstyled c-global-dashboard-logo",
                      on: { click: _vm.onGlobalDashboardClick },
                    },
                    [
                      _c("avatar", {
                        staticClass: "c-avatar",
                        attrs: {
                          src: "/assets/images/group-income-icon-transparent-circle.png",
                          alt: "Global dashboard logo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.hasNewNews
                    ? _c("badge", {
                        attrs: {
                          type: "compact",
                          "data-test": "globalDashboardBadge",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.groupsByName, function (group, index) {
            return _c(
              "li",
              {
                key: "group-" + index,
                staticClass: "c-group-list-item group-badge",
                class: {
                  "is-active":
                    !_vm.isInGlobalDashboard &&
                    _vm.currentGroupId === group.contractID,
                },
              },
              [
                _c(
                  "tooltip",
                  { attrs: { direction: "right", text: group.groupName } },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "c-group-picture is-unstyled",
                        on: {
                          click: function ($event) {
                            return _vm.handleMenuSelect(group.contractID)
                          },
                        },
                      },
                      [
                        _c("avatar", {
                          staticClass: "c-avatar",
                          attrs: {
                            src: _vm.groupPictureForContract(group.contractID),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.badgeVisiblePerGroup[group.contractID]
                      ? _c("badge", {
                          attrs: {
                            type: "compact",
                            "data-test": "groupBadge-" + group.groupName,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "li",
            { staticClass: "c-group-list-item" },
            [
              _c(
                "tooltip",
                {
                  attrs: {
                    direction: "right",
                    text: _vm.L("Create a new group"),
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "is-icon has-background",
                      attrs: {
                        "data-test": "createGroup",
                        "aria-label": _vm.L("Add a group"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.openModal("GroupCreationModal")
                        },
                      },
                    },
                    [_c("i", { staticClass: "icon-plus" })]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-69cbfde9_0", { source: ".c-badge[data-v-69cbfde9] {\n  top: 0;\n  right: 1px;\n  z-index: 2;\n}\n.c-group-list[data-v-69cbfde9] {\n  width: 3.5rem;\n  padding-top: 0.7rem;\n  background-color: var(--general_1);\n}\n.c-group-list-item[data-v-69cbfde9] {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 3.2rem;\n  margin-bottom: 0.25rem;\n}\n.group-badge[data-v-69cbfde9]::before {\n  content: \"\";\n  position: absolute;\n  width: 3rem;\n  height: 3rem;\n  border: 1px solid transparent;\n  border-radius: 50%;\n  transform: scale(0.7);\n  transition: all 0.25s cubic-bezier(0.18, 0.89, 0.32, 1.38);\n}\n.group-badge.is-active[data-v-69cbfde9]::before {\n  transform: scale(1);\n  border-color: var(--text_0);\n  animation: spin-data-v-69cbfde9 0.5s ease-out;\n}\n.group-badge[data-v-69cbfde9]:not(.is-active) {\n  cursor: pointer;\n}\n.group-badge[data-v-69cbfde9]:not(.is-active):focus::before, .group-badge[data-v-69cbfde9]:not(.is-active):hover::before {\n  border-color: #fff;\n  border-width: 3px;\n  transform: scale(1.1);\n}\n@keyframes spin-data-v-69cbfde9 {\n0% {\n    transform: rotate(45deg);\n    filter: hue-rotate(0deg);\n    border-color: var(--primary_0) transparent transparent;\n}\n50% {\n    transform: rotate(315deg);\n    filter: hue-rotate(360deg);\n    border-color: var(--primary_0) transparent transparent;\n}\n100% {\n    transform: rotate(585deg);\n    border-color: #fff;\n}\n}\n.c-avatar[data-v-69cbfde9] {\n  position: relative;\n  z-index: 1;\n}\n.c-group-picture[data-v-69cbfde9] {\n  display: flex;\n}\n.c-group-picture.c-global-dashboard-logo[data-v-69cbfde9] {\n  background-color: var(--background_0);\n  border-radius: 50%;\n  width: 2.5rem;\n  height: 2.5rem;\n}\n.c-group-picture.c-global-dashboard-logo[data-v-69cbfde9]  img.c-avatar {\n  width: 1.75rem;\n  height: 1.75rem;\n}\n\n/*# sourceMappingURL=GroupsList.vue.map */", map: {"version":3,"sources":["frontend/views/containers/navigation/GroupsList.vue","GroupsList.vue"],"names":[],"mappings":"AA0JA;EACA,MAAA;EACA,UAAA;EACA,UAAA;ACzJA;AD4JA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;ACzJA;AD4JA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;ACzJA;AD6JA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,qBAAA;EACA,0DAAA;AC1JA;AD8JA;EACA,mBAAA;EACA,2BAAA;EACA,6CAAA;AC5JA;ADgKA;EACA,eAAA;AC9JA;ADgKA;EAEA,kBAAA;EACA,iBAAA;EACA,qBAAA;AC/JA;ADoKA;AACA;IACA,wBAAA;IACA,wBAAA;IACA,sDAAA;ACjKE;ADoKF;IACA,yBAAA;IACA,0BAAA;IACA,sDAAA;AClKE;ADqKF;IACA,yBAAA;IACA,kBAAA;ACnKE;AACF;ADsKA;EACA,kBAAA;EACA,UAAA;ACpKA;ADuKA;EACA,aAAA;ACpKA;ADsKA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;ACpKA;ADsKA;EACA,cAAA;EACA,eAAA;ACpKA;;AAEA,yCAAyC","file":"GroupsList.vue","sourcesContent":["<template lang='pug'>\nul.c-group-list(v-if='groupsByName.length' data-test='groupsList')\n  li.c-group-list-item.group-badge(:class='{ \"is-active\": isInGlobalDashboard }')\n    tooltip(\n      direction='right'\n      :text='L(\"Global dashboard\")'\n    )\n      button.c-group-picture.is-unstyled.c-global-dashboard-logo(@click='onGlobalDashboardClick')\n        avatar.c-avatar(\n          src='/assets/images/group-income-icon-transparent-circle.png'\n          alt='Global dashboard logo'\n        )\n      badge(\n        v-if='hasNewNews'\n        type='compact'\n        data-test='globalDashboardBadge'\n      )\n\n  li.c-group-list-item.group-badge(\n    v-for='(group, index) in groupsByName'\n    :key='`group-${index}`'\n    :class='{ \"is-active\": !isInGlobalDashboard && currentGroupId === group.contractID}'\n  )\n    tooltip(\n      direction='right'\n      :text='group.groupName'\n    )\n      button.c-group-picture.is-unstyled(@click='handleMenuSelect(group.contractID)')\n        avatar.c-avatar(:src='groupPictureForContract(group.contractID)')\n      badge(\n        v-if='badgeVisiblePerGroup[group.contractID]'\n        type='compact'\n        :data-test='`groupBadge-${group.groupName}`'\n      )\n\n  li.c-group-list-item\n    tooltip(\n      direction='right'\n      :text='L(\"Create a new group\")'\n    )\n      button(\n        class='is-icon has-background'\n        @click='openModal(\"GroupCreationModal\")'\n        data-test='createGroup'\n        :aria-label='L(\"Add a group\")'\n      )\n        i.icon-plus\n</template>\n\n<script>\nimport sbp from '@sbp/sbp'\nimport { mapGetters, mapState } from 'vuex'\nimport Avatar from '../../../../frontend/views/components/Avatar.vue'\nimport Badge from '../../../../frontend/views/components/Badge.vue'\nimport Tooltip from '../../../../frontend/views/components/Tooltip.vue'\nimport { OPEN_MODAL } from '../../../../frontend/utils/events.js'\nimport { fetchNews } from '../../../../frontend/views/utils/misc.js'\n\nexport default ({\n  name: 'GroupsList',\n  components: {\n    Avatar,\n    Badge,\n    Tooltip\n  },\n  data () {\n    return {\n      ephemeral: {\n        latestNewsDate: null\n      }\n    }\n  },\n  created () {\n    this.checkForNewNews()\n  },\n  computed: {\n    ...mapState([\n      'currentGroupId'\n    ]),\n    ...mapGetters([\n      'groupsByName',\n      'groupUnreadMessages',\n      'unreadGroupNotificationCountFor',\n      'ourPreferences'\n    ]),\n    badgeVisiblePerGroup () {\n      return Object.fromEntries(\n        this.groupsByName.map(group => ([\n          group.contractID,\n          this.groupUnreadMessages(group.contractID) + this.unreadGroupNotificationCountFor(group.contractID) > 0\n        ]))\n      )\n    },\n    isInGlobalDashboard () {\n      return this.$route.path.startsWith('/global-dashboard')\n    },\n    hasNewNews () {\n      // Don't show badge if we're currently on the news page\n      if (this.$route.path === '/global-dashboard/news-and-updates' ||\n        !this.ourPreferences?.lastSeenNewsDate ||\n        !this.ephemeral.latestNewsDate\n      ) {\n        return false\n      }\n\n      return new Date(this.ephemeral.latestNewsDate) > new Date(this.ourPreferences.lastSeenNewsDate)\n    }\n  },\n  methods: {\n    openModal (mode) {\n      sbp('okTurtles.events/emit', OPEN_MODAL, mode)\n    },\n    handleMenuSelect (id) {\n      id && this.changeGroup(id)\n\n      if (this.isInGlobalDashboard) {\n        this.$router.push('/dashboard')\n      }\n    },\n    onGlobalDashboardClick () {\n      this.$router.push(({ path: '/global-dashboard' }))\n    },\n    changeGroup (hash) {\n      const path = this.$route.path\n      const emptyGroupPicture = this.groupPictureForContract(hash) === ''\n      if (hash !== this.currentGroupId) {\n        sbp('gi.app/group/switch', hash)\n      }\n      if (emptyGroupPicture && path !== '/pending-approval') {\n        this.$router.push(({ path: '/pending-approval' }))\n      } else if (!emptyGroupPicture && path === '/pending-approval') {\n        this.$router.push(({ path: '/dashboard' }))\n      }\n    },\n    groupPictureForContract (contractID) {\n      return this.$store.state[contractID]?.settings?.groupPicture || ''\n    },\n    async checkForNewNews () {\n      try {\n        const data = await fetchNews()\n        if (data.length > 0) {\n          this.ephemeral.latestNewsDate = data[0].createdAt\n        }\n      } catch (error) {\n        console.error('Failed to check for new news:', error)\n      }\n    }\n  }\n}: Object)\n</script>\n\n<style lang=\"scss\" scoped>\n@import \"../../../../frontend/assets/style/_variables.scss\";\n\n.c-badge {\n  top: 0;\n  right: 1px; // Prevent badges from touching the vertical edge.\n  z-index: 2; // Make badges appear above group avatars.\n}\n\n.c-group-list {\n  width: 3.5rem;\n  padding-top: 0.7rem;\n  background-color: $general_1;\n}\n\n.c-group-list-item {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 3.2rem;\n  margin-bottom: 0.25rem;\n}\n\n.group-badge {\n  &::before {\n    content: \"\";\n    position: absolute;\n    width: 3rem;\n    height: 3rem;\n    border: 1px solid transparent;\n    border-radius: 50%;\n    transform: scale(0.7);\n    transition: all 0.25s cubic-bezier(0.18, 0.89, 0.32, 1.38);\n  }\n\n  &.is-active {\n    &::before {\n      transform: scale(1);\n      border-color: $text_0;\n      animation: spin 0.5s ease-out;\n    }\n  }\n\n  &:not(.is-active) {\n    cursor: pointer;\n\n    &:focus::before,\n    &:hover::before {\n      border-color: $white;\n      border-width: 3px;\n      transform: scale(1.1);\n    }\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(45deg);\n    filter: hue-rotate(0deg);\n    border-color: $primary_0 transparent transparent;\n  }\n\n  50% {\n    transform: rotate(315deg);\n    filter: hue-rotate(360deg);\n    border-color: $primary_0 transparent transparent;\n  }\n\n  100% {\n    transform: rotate(585deg);\n    border-color: $white;\n  }\n}\n\n.c-avatar {\n  position: relative;\n  z-index: 1;\n}\n\n.c-group-picture {\n  display: flex;\n\n  &.c-global-dashboard-logo {\n    background-color: $background_0;\n    border-radius: 50%;\n    width: 2.5rem;\n    height: 2.5rem;\n\n    ::v-deep img.c-avatar {\n      width: 1.75rem;\n      height: 1.75rem;\n    }\n  }\n}\n</style>\n",".c-badge {\n  top: 0;\n  right: 1px;\n  z-index: 2;\n}\n\n.c-group-list {\n  width: 3.5rem;\n  padding-top: 0.7rem;\n  background-color: var(--general_1);\n}\n\n.c-group-list-item {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 3.2rem;\n  margin-bottom: 0.25rem;\n}\n\n.group-badge::before {\n  content: \"\";\n  position: absolute;\n  width: 3rem;\n  height: 3rem;\n  border: 1px solid transparent;\n  border-radius: 50%;\n  transform: scale(0.7);\n  transition: all 0.25s cubic-bezier(0.18, 0.89, 0.32, 1.38);\n}\n.group-badge.is-active::before {\n  transform: scale(1);\n  border-color: var(--text_0);\n  animation: spin 0.5s ease-out;\n}\n.group-badge:not(.is-active) {\n  cursor: pointer;\n}\n.group-badge:not(.is-active):focus::before, .group-badge:not(.is-active):hover::before {\n  border-color: #fff;\n  border-width: 3px;\n  transform: scale(1.1);\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(45deg);\n    filter: hue-rotate(0deg);\n    border-color: var(--primary_0) transparent transparent;\n  }\n  50% {\n    transform: rotate(315deg);\n    filter: hue-rotate(360deg);\n    border-color: var(--primary_0) transparent transparent;\n  }\n  100% {\n    transform: rotate(585deg);\n    border-color: #fff;\n  }\n}\n.c-avatar {\n  position: relative;\n  z-index: 1;\n}\n\n.c-group-picture {\n  display: flex;\n}\n.c-group-picture.c-global-dashboard-logo {\n  background-color: var(--background_0);\n  border-radius: 50%;\n  width: 2.5rem;\n  height: 2.5rem;\n}\n.c-group-picture.c-global-dashboard-logo ::v-deep img.c-avatar {\n  width: 1.75rem;\n  height: 1.75rem;\n}\n\n/*# sourceMappingURL=GroupsList.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-69cbfde9"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "<template lang='pug'>\nul.c-group-list(v-if='groupsByName.length' data-test='groupsList')\n  li.c-group-list-item.group-badge(:class='{ \"is-active\": isInGlobalDashboard }')\n    tooltip(\n      direction='right'\n      :text='L(\"Global dashboard\")'\n    )\n      button.c-group-picture.is-unstyled.c-global-dashboard-logo(@click='onGlobalDashboardClick')\n        avatar.c-avatar(\n          src='/assets/images/group-income-icon-transparent-circle.png'\n          alt='Global dashboard logo'\n        )\n      badge(\n        v-if='hasNewNews'\n        type='compact'\n        data-test='globalDashboardBadge'\n      )\n\n  li.c-group-list-item.group-badge(\n    v-for='(group, index) in groupsByName'\n    :key='`group-${index}`'\n    :class='{ \"is-active\": !isInGlobalDashboard && currentGroupId === group.contractID}'\n  )\n    tooltip(\n      direction='right'\n      :text='group.groupName'\n    )\n      button.c-group-picture.is-unstyled(@click='handleMenuSelect(group.contractID)')\n        avatar.c-avatar(:src='groupPictureForContract(group.contractID)')\n      badge(\n        v-if='badgeVisiblePerGroup[group.contractID]'\n        type='compact'\n        :data-test='`groupBadge-${group.groupName}`'\n      )\n\n  li.c-group-list-item\n    tooltip(\n      direction='right'\n      :text='L(\"Create a new group\")'\n    )\n      button(\n        class='is-icon has-background'\n        @click='openModal(\"GroupCreationModal\")'\n        data-test='createGroup'\n        :aria-label='L(\"Add a group\")'\n      )\n        i.icon-plus\n</template>\n\n<script>\nimport sbp from '@sbp/sbp'\nimport { mapGetters, mapState } from 'vuex'\nimport Avatar from '../../../../frontend/views/components/Avatar.vue'\nimport Badge from '../../../../frontend/views/components/Badge.vue'\nimport Tooltip from '../../../../frontend/views/components/Tooltip.vue'\nimport { OPEN_MODAL } from '../../../../frontend/utils/events.js'\nimport { fetchNews } from '../../../../frontend/views/utils/misc.js'\n\nexport default ({\n  name: 'GroupsList',\n  components: {\n    Avatar,\n    Badge,\n    Tooltip\n  },\n  data () {\n    return {\n      ephemeral: {\n        latestNewsDate: null\n      }\n    }\n  },\n  created () {\n    this.checkForNewNews()\n  },\n  computed: {\n    ...mapState([\n      'currentGroupId'\n    ]),\n    ...mapGetters([\n      'groupsByName',\n      'groupUnreadMessages',\n      'unreadGroupNotificationCountFor',\n      'ourPreferences'\n    ]),\n    badgeVisiblePerGroup () {\n      return Object.fromEntries(\n        this.groupsByName.map(group => ([\n          group.contractID,\n          this.groupUnreadMessages(group.contractID) + this.unreadGroupNotificationCountFor(group.contractID) > 0\n        ]))\n      )\n    },\n    isInGlobalDashboard () {\n      return this.$route.path.startsWith('/global-dashboard')\n    },\n    hasNewNews () {\n      // Don't show badge if we're currently on the news page\n      if (this.$route.path === '/global-dashboard/news-and-updates' ||\n        !this.ourPreferences?.lastSeenNewsDate ||\n        !this.ephemeral.latestNewsDate\n      ) {\n        return false\n      }\n\n      return new Date(this.ephemeral.latestNewsDate) > new Date(this.ourPreferences.lastSeenNewsDate)\n    }\n  },\n  methods: {\n    openModal (mode) {\n      sbp('okTurtles.events/emit', OPEN_MODAL, mode)\n    },\n    handleMenuSelect (id) {\n      id && this.changeGroup(id)\n\n      if (this.isInGlobalDashboard) {\n        this.$router.push('/dashboard')\n      }\n    },\n    onGlobalDashboardClick () {\n      this.$router.push(({ path: '/global-dashboard' }))\n    },\n    changeGroup (hash) {\n      const path = this.$route.path\n      const emptyGroupPicture = this.groupPictureForContract(hash) === ''\n      if (hash !== this.currentGroupId) {\n        sbp('gi.app/group/switch', hash)\n      }\n      if (emptyGroupPicture && path !== '/pending-approval') {\n        this.$router.push(({ path: '/pending-approval' }))\n      } else if (!emptyGroupPicture && path === '/pending-approval') {\n        this.$router.push(({ path: '/dashboard' }))\n      }\n    },\n    groupPictureForContract (contractID) {\n      return this.$store.state[contractID]?.settings?.groupPicture || ''\n    },\n    async checkForNewNews () {\n      try {\n        const data = await fetchNews()\n        if (data.length > 0) {\n          this.ephemeral.latestNewsDate = data[0].createdAt\n        }\n      } catch (error) {\n        console.error('Failed to check for new news:', error)\n      }\n    }\n  }\n}: Object)\n</script>\n\n<style lang=\"scss\" scoped>\n@import \"../../../../frontend/assets/style/_variables.scss\";\n\n.c-badge {\n  top: 0;\n  right: 1px; // Prevent badges from touching the vertical edge.\n  z-index: 2; // Make badges appear above group avatars.\n}\n\n.c-group-list {\n  width: 3.5rem;\n  padding-top: 0.7rem;\n  background-color: $general_1;\n}\n\n.c-group-list-item {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 3.2rem;\n  margin-bottom: 0.25rem;\n}\n\n.group-badge {\n  &::before {\n    content: \"\";\n    position: absolute;\n    width: 3rem;\n    height: 3rem;\n    border: 1px solid transparent;\n    border-radius: 50%;\n    transform: scale(0.7);\n    transition: all 0.25s cubic-bezier(0.18, 0.89, 0.32, 1.38);\n  }\n\n  &.is-active {\n    &::before {\n      transform: scale(1);\n      border-color: $text_0;\n      animation: spin 0.5s ease-out;\n    }\n  }\n\n  &:not(.is-active) {\n    cursor: pointer;\n\n    &:focus::before,\n    &:hover::before {\n      border-color: $white;\n      border-width: 3px;\n      transform: scale(1.1);\n    }\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(45deg);\n    filter: hue-rotate(0deg);\n    border-color: $primary_0 transparent transparent;\n  }\n\n  50% {\n    transform: rotate(315deg);\n    filter: hue-rotate(360deg);\n    border-color: $primary_0 transparent transparent;\n  }\n\n  100% {\n    transform: rotate(585deg);\n    border-color: $white;\n  }\n}\n\n.c-avatar {\n  position: relative;\n  z-index: 1;\n}\n\n.c-group-picture {\n  display: flex;\n\n  &.c-global-dashboard-logo {\n    background-color: $background_0;\n    border-radius: 50%;\n    width: 2.5rem;\n    height: 2.5rem;\n\n    ::v-deep img.c-avatar {\n      width: 1.75rem;\n      height: 1.75rem;\n    }\n  }\n}\n</style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__